var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDropOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9833 2.5C17.354 2.5 24 10.3839 24 16C24 21.5228 19.5229 26 14 26C8.47715 26 4 21.5228 4 16C4 10.3821 10.6167 2.5 13.9833 2.5ZM13.9833 4.5C13.3308 4.5 11.2452 6.06548 9.50127 8.14295C7.338 10.7199 6 13.5598 6 16C6 20.4183 9.58172 24 14 24C18.4183 24 22 20.4183 22 16C22 13.5613 20.6562 10.7222 18.4833 8.14453C16.7321 6.06713 14.6374 4.5 13.9833 4.5Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDropOutline);
export default __webpack_public_path__ + "static/media/water_drop_outline.d95d64056396a330e31091fa5c23c8e3.svg";
export { ForwardRef as ReactComponent };